/**
 * Copyright © 2026 Adnuntius AS.
 */
import {LocalStorage} from "./local-storage";
import * as moment from 'moment';
import * as _ from "lodash";

type UpdateSessionData = {
  authToken: string;
  context: string;
  expires: string;
};

export class UpdateSession {
  private static instance: UpdateSession;

  static readonly UPDATE_SESSION_KEY = 'update-session';

  updateSession: UpdateSessionData | any;

  private constructor() {
  }

  public static obtain(): UpdateSession {
    if (!this.instance) {
      this.instance = new UpdateSession();
    }
    const localStorageSession = LocalStorage.obtain().getItem(UpdateSession.UPDATE_SESSION_KEY);
    this.instance.updateSession = _.isObject(localStorageSession) && !_.isEmpty(localStorageSession) ? localStorageSession : {};
    if (this.instance.isExpired()) {
      this.instance.destroy();
      this.instance.updateSession = {};
    }
    return this.instance;
  }

  public static obtainData(): UpdateSessionData {
    return this.obtain().updateSession;
  }

  isExpired(): boolean {
    const expires = moment(this.updateSession.expires, moment.ISO_8601, true);
    return !expires.isValid() || expires.isSameOrBefore(moment());
  }

  init(context: string, authToken: string): UpdateSessionData {
    this.updateSession.context = context;
    this.updateSession.authToken = authToken;
    this.updateSession.expires = moment().add(3600, 's').toISOString();
    LocalStorage.obtain().setItem(UpdateSession.UPDATE_SESSION_KEY, this.updateSession);
    return UpdateSession.obtainData();
  }

  destroy() {
    LocalStorage.obtain().remove(UpdateSession.UPDATE_SESSION_KEY);
  }

  static isAdvertiserUpdatePath(path: string): boolean {
    return !!path && path.indexOf('/advertiser') === 0;
  }
}
